export var DateRangeKey;
(function (DateRangeKey) {
    DateRangeKey["THIS_WEEK"] = "this-week";
    DateRangeKey["THIS_MONTH"] = "this-month";
    DateRangeKey["THIS_YEAR"] = "this-year";
    DateRangeKey["THIS_UK_TAX_YEAR"] = "this-uk-tax-year";
    DateRangeKey["PAST_YEAR"] = "past-year";
    DateRangeKey["PAST_SIX_MONTHS"] = "past-six-months";
    DateRangeKey["PAST_QUARTER"] = "past-quarter";
    DateRangeKey["PAST_MONTH"] = "past-month";
    DateRangeKey["PAST_WEEK"] = "past-week";
    DateRangeKey["PAST_UK_TAX_YEAR"] = "past-uk-tax-year";
    DateRangeKey["ALL_TIME"] = "all-time";
})(DateRangeKey || (DateRangeKey = {}));
//# sourceMappingURL=index.js.map